<template>
  <tr>
    <td>{{ tag }}</td>
    <td v-if="control">{{ value }}</td>
    <td v-else>
      {{ indicators }} |
      <marc-subfield v-for="(subfield, index) in value.subfields"
                     :key="`sf${index}`"
                     :subfield="subfield"/>
    </td>
  </tr>
</template>

<script>
import MarcSubfield from "./MarcSubfield.vue"
export default {
  name: "MarcField",
  components: {
    MarcSubfield
  },
  computed: {
    tag: function() {
      return Object.keys(this.field)[0];
    },
    value: function() {
      return Object.values(this.field)[0];
    },
    control: function() {
      return typeof(this.value) !== 'object';
    },
    indicators: function() {
      const ind1 = this.value.ind1 == " " ? "_" : this.value.ind1;
      const ind2 = this.value.ind2 == " " ? "_" : this.value.ind2;
      return ind1 + ind2;
    }
  },
  props: {
    field: Object
  }
}
</script>

<style scoped>

</style>
